<div class="pie-column">
    <div class="chart-title-label">Truck Assign/Unassign</div>
    <div class="chart-component">
        <ngx-charts-pie-chart class="legend-title-style" [view]="chartViewFrame" [scheme]="colorScheme"
            [results]="truckData" [animations]="true" [legend]="false"
            [legendTitle]="legendTruckTitle" [legendPosition]="legendPosition"
            [explodeSlices]="explodeSlices" [labels]="showLabel" [doughnut]="false"
            [labelFormatting]="customAssignTruckLabel" [arcWidth]="arcWidth" [gradient]="gradient"
            [tooltipDisabled]="tooltipDisabled" [tooltipText]="pieTooltipText" (dblclick)="dblclick($event)"
            (select)="select($event)" (activate)="activate($event)" (deactivate)="deactivate($event)">
        </ngx-charts-pie-chart>
        <div class="truck-status-container">
            <div class="truck-status-title">Truck Status</div>
            <div class="assigned-truck-status-container">
                <div class="assigned-truck-status-color"></div>
                <div class="truck-stauts-label">Assigned Truck</div>
            </div>
            <div class="assigned-truck-status-container">
                <div class="unassigned-truck-status-color"></div>
                <div class="truck-stauts-label">Unassign Truck</div>
            </div>
        </div>
    </div>
</div>

    <!-- <div class="pie-column">
        <div class="chart-title-label">Truck Assign/Unassign</div>
        <div class="chart-component">
            <canvasjs-chart [options]="chartOptions" [styles]="{width: chartWidth, height:'300px'}"></canvasjs-chart>    
            <div class="truck-status-container">
                <div class="truck-status-title">Truck Status</div>
                <div class="assigned-truck-status-container">
                    <div class="assigned-truck-status-color"></div>
                    <div class="truck-stauts-label">Assigned Truck</div>
                </div>
                <div class="assigned-truck-status-container">
                    <div class="unassigned-truck-status-color"></div>
                    <div class="truck-stauts-label">Unassign Truck</div>
                </div>
            </div>
        </div>
        
    </div> -->